import { Module } from 'vuex';
import $rq from '@/api/api';

export interface Client {
    id: string;
    name: string;
    accountNumber?: string;
    accessGroups?: Array<string>;
    city?: string;
    mainContact?: {
        firstName: string;
        lastName: string;
    };
    active?: boolean;
    [key: string]: unknown;
}

export interface ClientState {
    client: Client;
    [key: string]: unknown;
}

const defaultState: ClientState = {
    client: {
        id: '',
        name: '',
    },
};

const client: Module<ClientState, unknown> = {
    state: () => ({ ...defaultState }),

    mutations: {
        setClientState(state, client: Client) {
            state.client = { ...client };
        },
        resetClientState(state) {
            state.client = { ...defaultState.client };
        },
    },

    actions: {
        async getClientInfo({ commit, dispatch }, clientId: string) {
            try {
                const response = await $rq.getClientInfo(clientId);
                if (response) {
                    commit('setClientState', response);
                } else {
                    dispatch('resetClientInfo');
                }
            } catch (err) {
                dispatch('resetClientInfo');
            }
        },
        resetClientInfo({ commit }) {
            commit('resetClientState');
        },
    },

    getters: {
        client: (state) => state.client,
    },
};

export default client;
